var map = {
	"./nat-1-large.jpg": 845,
	"./nat-2-large.jpg": 846,
	"./nat-3-large.jpg": 847
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 844;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/nat\-.*\-large\.jpg$
// module id = 844
// module chunks = 0